import { apiClient } from '../client'
import type { ApiSuccessResponse } from '../../types/api'
import type { ChangePasswordPayload, ProfileUser, UpdateProfilePayload } from '../../types/profile'

/** Profile API — components call this service only, never apiClient. */
export const profileService = {
  async getProfile() {
    const { data } = await apiClient.get<ApiSuccessResponse<ProfileUser>>('/profile')
    return data
  },

  async updateProfile(payload: UpdateProfilePayload) {
    // PHP does not parse multipart bodies on PUT — use JSON for text-only updates
    // and POST multipart when uploading a file.
    if (payload.image) {
      const formData = new FormData()
      formData.append('salutation', payload.salutation)
      formData.append('first_name', payload.first_name)
      formData.append('surname', payload.surname)
      formData.append('phone_number', payload.phone_number ?? '')
      formData.append('image', payload.image)

      const { data } = await apiClient.post<ApiSuccessResponse<ProfileUser>>('/profile', formData)
      return data
    }

    const { data } = await apiClient.put<ApiSuccessResponse<ProfileUser>>('/profile', {
      salutation: payload.salutation,
      first_name: payload.first_name,
      surname: payload.surname,
      phone_number: payload.phone_number,
      remove_image: payload.remove_image ?? false,
    })

    return data
  },

  async changePassword(payload: ChangePasswordPayload) {
    const { data } = await apiClient.put<ApiSuccessResponse<null>>('/profile/password', payload)
    return data
  },
}
